import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useCallback, useContext, useMemo, useState, } from 'react';
import convertBasketProductPriceBandsToGenericBands from '@widgets/shared/convertBasketProductPriceBandsToGenericBands';
import { BandsList } from '@widgets/MiscProducts/styles';
import Band from '@genericBookings/components/AttendeesSelector/components/Band';
import NumberInput from '@widgets/shared/components/NumberInput';
import API from '@widgets/shared/API/connection';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
const adjustMiscProductQuantity = AwesomeDebouncePromise(API.adjustMiscProductQty, 500);
function MiscForm({ postSubmit, options, shouldSubmit, }) {
    const [submitting, setSubmitting] = useState(false);
    const { item, buttonText } = useContext(options);
    const { watch, getValues, setValue, formState: { errors, isValid }, } = useFormContext();
    const priceBands = item.PriceBands.map((_, idx) => watch(`PriceBands.${idx}`));
    const bands = useMemo(() => convertBasketProductPriceBandsToGenericBands(item.PriceBands), [item.PriceBands]);
    const totalQuantity = useMemo(() => (priceBands
        ? priceBands.reduce((carry, band) => carry + band.Units, 0)
        : 0), [priceBands]);
    const formValid = useMemo(() => isValid && !submitting && totalQuantity !== 0, [isValid, totalQuantity, submitting]);
    const handleFormSubmit = useCallback((e) => {
        e.preventDefault();
        // do something
        setSubmitting(true);
        const promises = item.PriceBands.map((band, idx) => () => adjustMiscProductQuantity(item.MiscellaneousId, item.MiscellaneousType, band.PriceBandId, getValues(`PriceBands.${idx}.Units`), item.PriceBands));
        if (shouldSubmit) {
            Promise.all(promises.map((fn) => fn()))
                .then((res) => {
                const lastRes = res.at(-1);
                if (lastRes) {
                    window.dispatchEvent(new CustomEvent('basket.modify', {
                        detail: lastRes,
                    }));
                }
            })
                .finally(() => {
                postSubmit();
            });
        }
        else {
            postSubmit(promises);
        }
        // handleSubmit()
        //   .finally(() => setSubmitting(false));
    }, [getValues, item, postSubmit, shouldSubmit]);
    return (_jsx("div", { children: _jsxs("form", { method: "POST", noValidate: true, onSubmit: handleFormSubmit, children: [_jsx(BandsList, { children: bands.map((band) => (_jsx(Band, { band: band, children: _jsx(NumberInput, { name: band.FieldName, bands: bands, band: band, price: band.UnitPrice, showPrice: false, accent: "#00AEEF" }) }))) }), _jsx("button", { disabled: !formValid, className: "btn btn--primary btn--full", type: "submit", children: buttonText ?? 'Reserve' })] }) }));
}
export default MiscForm;
